<template>
	<div id="paikejl">
		<div class="printBox">
			<div class="print_head" style="margin-top: 50px;font-size: 26px;">{{shaist}} - {{shaiet}}</div>
			<div class="print_head">{{weeks}}</div>
			<table style="width: 95%;margin: auto;" border="1" cellpadding="0" cellspacing="0">
				<thead>
					<tr style="display: flex;">
						<th style="flex: 1;text-align: center;padding: 8px 0;"></th>
						<th v-for="(k,index) in kjl.class_room_names" style="flex: 1;text-align: center;padding: 8px 0;">
							{{k.content}}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(it,iidex) in kjl.infos" style="display: flex;">
						<td v-for="(kks,index) in it" v-if="index==0" style="flex: 1;text-align: center;padding: 5px 0;">
							<div>
								<div style="margin-top: 18px;">
									<span>上课：</span>
									<span>{{kks[0]}}</span>
								</div>
								<div>
									<span>下课：</span>
									<span>{{kks[1]}}</span>
								</div>
							</div>
						</td>
						<td v-for="(kk,index) in it" v-if="index>0" style="flex: 1;text-align: center;padding: 5px 0;">
							<div :class="{boxshadow:kk.kc_name,bgbai:kk.kc_name}">
								<div v-if="kk.kc_name">
									<div>课程/班级名称：</div>
									<div>{{kk.kc_name}}</div>
								</div>
								<div v-if="kk.kc_name">
									<div>{{kk.yueling}}~{{kk.yueling2}}月：</div>
									<div>{{kk.username}}</div>
								</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>

		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				copygd: false,
				_isDestroyed: '',
				stime: '',
				etime: '',
				stimeX: '',
				etimeX: '',
				zhouX: '12',
				pickerOptions0: {
					disabledDate: ''
				},
				zhou: '12',
				startTime: new Date(1989, 1, 8, 0, 0),
				endTime: new Date(1989, 1, 8, 0, 0),
				sstartTime: '',
				yjpkt: false,
				xgt: false,
				ylfb: false,
				token: '',
				kjl: '',
				ylfbdata: '',
				xuan: '',
				shaist: '',
				shaiet: '',
				week: '3',
				weeks:'星期三',//星期几
				kebtn: '',
				kedata: '',
				xuanzhong: '0',
				shulength: '',
				xiuindex: "",
				xiu_start: '',
				xiu_end: '',
				print_lenth:1,
				week_list: [{
						name: '星期一',
						id: '1'
					},
					{
						name: '星期二',
						id: '2'
					},
					{
						name: '星期三',
						id: '3'
					},
					{
						name: '星期四',
						id: '4'
					},
					{
						name: '星期五',
						id: '5'
					},
					{
						name: '星期六',
						id: '6'
					},
					{
						name: '星期日',
						id: '7'
					},
				],
				need_classes:[],
				isPrint:false,//打印
			}
		},
		methods: {
			yijianp: function() {
				//            this.yjpkt=false
				//            stimeX etimeX
				let self = this;

				$.ajax({
					url: process.env.apiUrl + 'saas/paike/one_key_class',
					dataType: 'json',
					type: 'post',
					data: {
						token: self.token,
						t_start_time: self.stime,
						t_end_time: self.etime,
						copygd: self.copygd
					},
					success: function(data) {
						if (data.status == 1) {
							self.$message.success(`${data.msg}`)
							self.yjpkt = false

							setTimeout(function(){
                                location.reload()
							},2000)
						} else {
							self.$message.error(`${data.msg}`)
						}

					}
				})
			},
			tiaoxj: function() {
				this.$router.push({
					name: 'paike'
				})
			},
			tiaoxiugai: function() {
				this.$router.push({
					name: 'paikexiu',
					query: {
						week: this.week,
						start: this.shaist,
						end: this.shaiet
					}
				})
			},
			zhouqs: function(pk, stime, etime) {
				this.xuan = pk;
				this.shaist = stime;
				this.shaiet = etime;
				let self = this;
				self.shai();
			},
			ylfbfn: function() {
				let self = this;
				$.ajax({
					url: process.env.apiUrl + 'saas/paike/zhouke',
					dataType: 'json',
					type: 'post',
					data: {
						token: this.token
					},
					success: function(data) {
						if (data.status == 1) {
							self.ylfb = true;

							self.kebtn = data.data.cycles
							self.kedata = data.data.data
							self.shulength = self.kedata[self.xuanzhong].length
						} else {
							self.$message.error('没有课程统计记录')
						}
					}
				})
			},
			shuchuTime: function() {
				let time = new Date(this.startTime).getTime() + 60000 * 45;

				function timestampToTime(timestamp) {
					var date = new Date(timestamp)
					var h = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours()) + ':';
					var m = date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes() + ':';
					var s = date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds();
					return h + m + s;
				}
				this.endTime = new Date(time)
				this.sstartTime = timestampToTime(time)
			},
			stfnX: function() {
				let self = this;
				let zhounum = Number(self.zhouX)
				let d = new Date(self.stimeX).getTime() + 86400000 * 7 * zhounum - 86400000;

				function timestampToTime(timestamp) {
					var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
					var Y = date.getFullYear() + '-';
					var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
					//                var D = date.getDate() + ' ';
					var D = date.getDate() + 1 < 10 ? '0' + (date.getDate()) : date.getDate();
					var h = date.getHours() + ':';
					var m = date.getMinutes() + ':';
					var s = date.getSeconds();
					//                return Y+M+D+h+m+s;
					return Y + M + D;
				}
				this.etimeX = timestampToTime(d)

			},
			stfn2X: function() {
				let self = this;
				let zhounum = Number(self.zhouX)
				let d = new Date(self.stimeX).getTime() + 86400000 * 7 * zhounum - 86400000;

				function timestampToTime(timestamp) {
					var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
					var Y = date.getFullYear() + '-';
					var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
					//                var D = date.getDate() + ' ';
					var D = date.getDate() + 1 < 10 ? '0' + (date.getDate()) : date.getDate();
					var h = date.getHours() + ':';
					var m = date.getMinutes() + ':';
					var s = date.getSeconds();
					return Y + M + D;
				}
				this.etimeX = timestampToTime(d)
			},
			stfn: function() {
				let self = this;
				let zhounum = Number(self.zhou)
				let d = new Date(self.stime).getTime() + 86400000 * 7 * zhounum - 86400000;

				function timestampToTime(timestamp) {
					var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
					var Y = date.getFullYear() + '-';
					var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
					//                var D = date.getDate() + ' ';
					var D = date.getDate() + 1 < 10 ? '0' + (date.getDate()) : date.getDate();
					var h = date.getHours() + ':';
					var m = date.getMinutes() + ':';
					var s = date.getSeconds();
					//                return Y+M+D+h+m+s;
					return Y + M + D;
				}
				this.etime = timestampToTime(d)
			},
			stfn2: function() {
			},
			zhoufnX: function() {
				let self = this;
				let zhounum = Number(self.zhouX)
				let d = new Date(self.stimeX).getTime() + 86400000 * 7 * zhounum - 86400000;

				function timestampToTime(timestamp) {
					var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
					var Y = date.getFullYear() + '-';
					var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';

					var D = date.getDate() + 1 < 10 ? '0' + (date.getDate()) : date.getDate();
					var h = date.getHours() + ':';
					var m = date.getMinutes() + ':';
					var s = date.getSeconds();
					return Y + M + D;
				}
				this.etimeX = timestampToTime(d)
			},
			zhoufn: function() {
				let self = this;
				let zhounum = Number(self.zhou)
				let d = new Date(self.stime).getTime() + 86400000 * 7 * zhounum - 86400000;

				function timestampToTime(timestamp) {
					var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
					var Y = date.getFullYear() + '-';
					var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
					//                var D = date.getDate() + ' ';
					var D = date.getDate() + 1 < 10 ? '0' + (date.getDate()) : date.getDate();
					var h = date.getHours() + ':';
					var m = date.getMinutes() + ':';
					var s = date.getSeconds();
					//                return Y+M+D+h+m+s;
					return Y + M + D;
				}

				this.etime = timestampToTime(d)
				//        Date.prototype.Format = function (fmt) {
				//            var o = {
				//                "M+": this.getMonth() + 1, //月份
				//                "d+": this.getDate(), //日
				//                "h+": this.getHours(), //小时
				//                "m+": this.getMinutes(), //分
				//                "s+": this.getSeconds(), //秒
				//                "q+": Math.floor((this.getMonth() + 3) / 3), //季度
				//                "S": this.getMilliseconds() //毫秒
				//            };
				//            if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
				//            for (var k in o)
				//                if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
				//            return fmt;
				//        }
				//            this.etime= new Date(d).Format("yyyy-MM-dd");
				//Format("输入你想要的时间格式:yyyy-MM-dd,yyyyMMdd")

				//
				//
				//
				//
				//
				//            this.etime=d;
			},
			xiugaipaike: function() {
				this.xgt = true
				let self = this;
				self.stimeX = ""
				self.etimeX = ""
				$.ajax({
					url: process.env.apiUrl + 'saas/paike/zhouke',
					dataType: 'json',
					type: 'post',
					data: {
						token: this.token
					},
					success: function(data) {
						if (data.status == 1) {
							self.kebtn = data.data.cycles
							self.xiuindex = 0
							self.xiu_start = data.data.cycles[0].start_time
							self.xiu_end = data.data.cycles[0].end_time
						} else {
							self.$message.error('没有课程统计记录')
						}
					}

				})
			},
			// 修改排课（弹窗）
			xgpk: function(i, s, e) {
				this.xiuindex = i
				this.xiu_start = s
				this.xiu_end = e
			},
			// 修改排课确认（弹窗）
			xiu_confirm: function() {
				let self = this;
				$.ajax({
					url: process.env.apiUrl + 'saas/paike/modify_pk_cycle',
					dataType: 'json',
					type: 'post',
					data: {
						token: self.token,
						x_start_time: self.stimeX,
						x_end_time: self.etimeX,
						y_start_time: self.xiu_start,
						y_end_time: self.xiu_end,
						type: 3
					},
					success: function(data) {
						if (data.status == 1) {
							self.$message.success(data.msg)
							self.xgt = false
							self.shai()
						} else {
							self.$message.error(data.msg)
						}
					}

				})
			},
			shai: function() {
				let self = this;
				$.ajax({
					url: process.env.apiUrl + 'saas/paike/index',
					dataType: 'json',
					type: 'post',
					data: {
						type: 1,
						token: self.token,
						start_time: self.shaist,
						end_time: self.shaiet,
						week: self.week
					},
					success: function(data) {
						if(data.status == 1){
							self.kjl = data.data;
							for (var i = 0; i < data.data.pk_records.length; i++) {
								if (data.data.pk_records[i].chose == 1) {
									self.xuan = i
								}
							}
							setTimeout(()=>{
								var newstr = document.getElementById('paikejl').innerHTML
								document.body.innerHTML = newstr
								window.print()
							},1000)
							setTimeout(()=>{
								self.$router.push('paikejl')
								location.reload()
							},2000)
						}
					}
				})
			},
		},
		watch: {
			//星期格式化
			week() {
				if(this.week){
					for(let i in this.week_list){
						if(this.week_list[i].id == this.week){
							this.weeks = this.week_list[i].name
						}
					}
				}
			}
		},
		mounted: function() {
			this._isDestroyed = false;

			let self = this;
			self.token = $.cookie('token');
			self.shaist = self.$route.query.start_time
			self.shaiet = self.$route.query.end_time
			self.week = self.$route.query.week

			$.ajax({
				url: process.env.apiUrl + 'saas/paike/index',
				dataType: 'json',
				type: 'post',
				data: {
					token: this.token,
					type: 1
				},
				success: function(data) {
					self.need_classes = data.data.need_classes;
					self.kjl = data.data;
					for (var i = 0; i < data.data.pk_records.length; i++) {
						if (data.data.pk_records[i].chose == 1) {
							self.xuan = i
// 							self.shaist = data.data.pk_records[i].start_time;
// 							self.shaiet = data.data.pk_records[i].end_time;
						}
					}
					self.shai()
				}
			})

			let date = new Date()
			Date.prototype.Format = function(fmt) {
				var o = {
					"M+": this.getMonth() + 1, //月份
					"d+": this.getDate(), //日
					"h+": this.getHours(), //小时
					"m+": this.getMinutes(), //分
					"s+": this.getSeconds(), //秒
					"q+": Math.floor((this.getMonth() + 3) / 3), //季度
					"S": this.getMilliseconds() //毫秒
				};
				if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
				for (var k in o)
					if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" +
						o[k]).substr(("" + o[k]).length)));
				return fmt;
			}
			let f = new Date().Format("yyyy-MM-dd");
			this.stime = f;

			//日期格式转换e
			let d = new Date(this.stime).getTime() + 86400000 * 7 * 12 - 86400000;

			function timestampToTime(timestamp) {
				var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
				var Y = date.getFullYear() + '-';
				var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
				//                var D = date.getDate() + ' ';
				var D = date.getDate() + 1 < 10 ? '0' + (date.getDate()) : date.getDate();
				var h = date.getHours() + ':';
				var m = date.getMinutes() + ':';
				var s = date.getSeconds();
				//                return Y+M+D+h+m+s;
				return Y + M + D;
			}
			this.etime = timestampToTime(d);

			this.pickerOptions0.disabledDate = function disabledDate(time) {
				return time.getTime() < Date.now() - 8.64e7;
			}

			// this.shai()

		}


	}
</script>

<style scoped>
	#paikejl {
		min-height: 100%;
		background: #f8f8f8;
		margin: 0;
		box-sizing: border-box;
		color: #666;
		font-size: 12px;
	}

	.activex {
		color: #8CBB77;
		border-color: #8CBB77;
	}

	.bgbai {
		background: #fff;
	}

	#paikejl * {
		box-sizing: border-box;
	}

	.xuanz.active {
		background: #79c4c7;
		color: #fff;
	}

	#paikejl ul,
	p,
	label {
		margin: 0;
		padding: 0;
	}

	.ziBtn {
		background: #8CBB77;
		color: #fff;
		padding-top: 5px;
		padding-bottom: 5px;
	}

	.tanbg {
		background-image: url(/static/qmsj/img/lanshux.png), url(/static/qmsj/img/lanshux.png);
		background-size: 2px 100%;
		background-position: 33% center, 66% center;
		background-repeat: no-repeat;
	}

	.xiala {
		width: 140px;
		height: 28px;
		line-height: 28px;
		background-color: #fff;
		background-image: none;
		border-radius: 4px;
		border: 1px solid #dcdfe6;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		color: #606266;
		display: inline-block;
		font-size: 13px;
		outline: 0;
		padding: 0 15px;
		-webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
		transition: border-color .2s cubic-bezier(.645, .045, .355, 1);

	}
	.print_head{
		width: 94.9%;
		margin: auto;
		border: 2px solid;
		text-align: center;
		border-bottom: 0;
		padding: 5px 0;
		font-size: 18px;
		box-sizing: border-box;
	}

</style>
<style>
	#paikejl .sjcj .el-input--suffix .el-input__inner {
		padding-right: 0;
		padding-left: 5px;
	}

	#paikejl .sjcj .el-input__prefix {
		display: none;
	}

	#paikejl .sjcj .el-input__icon .el-icon-time {
		display: none;
	}

	#paikejl .sjcj .el-input__inner {
		padding-right: 0;
		padding-left: 5px;
	}

	.el-dialog__header{
		background-color: #8CBB77;
		padding: 10px 10px 10px 20px;
	}
	.el-dialog__headerbtn{
		top: 11px;
	}

	.print_page{
		page-break-after: always;
	}
	@media print {
		.print_head{
			width: 95%;
			margin: auto;
			border: 1px solid;
			border-bottom: 0;
			display: block !important;
			text-align: center;
			font-size: 20px;
			padding: 5px 0;
		}
		.print_show{
			visibility: hidden;
		}
		table{

		}
		th,td{
			font-size: 12px;
		}

	}
	@page{
		size: auto;
		margin: 0mm;
	}

	.youce[data-v-4ec9cc57]{
		padding-left: 0;
	}
	/*.right_bottom {*/
		/*display: none !important;*/
	/*}*/

	/*.topbar,*/
	/*.right_top,*/
	/*.navbar-box {*/
		/*display: none !important;*/
	/*}*/

	.box_z[data-v-4ec9cc57]{
		width: 100%;
		border-radius: 0 !important;
	}
</style>



// WEBPACK FOOTER //
// src/pages/paike/paike_print.vue